/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function e({associatedLayer:e,serviceUpdateTimeStamp:t}){const n=e?.editingInfo?.lastEditDate,r=e?.serverGens,a=null!=n,i=null!=t,s=a&&i&&t.lastUpdate!==n.getTime();return a&&(s||!i&&r?.minServerGen!==r?.serverGen)}export{e as cacheIsOutOfSync};
